import * as React from 'react';
import "react-datepicker/dist/react-datepicker.css";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import FormControl from '@mui/material/FormControl';
import { ValidationMessages } from './ValidationMessages';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import {
    Grid, TextField,
} from '@mui/material';
export default function RedQuickDatePicker(props: any) {

    let { value } = props;
    if (value && value.seconds) {
        value = new Date(value.seconds * 1000);
    }
    else if (value && value._seconds) {
        value = new Date(value._seconds * 1000);
    }
    else if (typeof value === 'number') {
        value = new Date(value);
    }
    return (
        <Grid item xs={12} sm={12} lg={12} sx={{ pt: { xs: 2, sm: '0 !important' } }}>
            <FormControl variant="standard">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        disabled={props.disabled}
                        renderInput={(props) => <TextField fullWidth {...props} helperText="" />}
                        label={props.title}
                        value={value}
                        onChange={(newValue: Date | null) => {
                            if (props.onChange) {
                                props.onChange(newValue);
                            }
                        }}
                    /></LocalizationProvider>
                <ValidationMessages invalid={props.invalid} />
            </FormControl>
        </Grid>
    );
}